import { CrudStoreBase } from './crudStoreBase';
import { ReferralAgentDto } from '../services/referralAgent/dto/referralAgentDto';
import referralAgentService from '../services/referralAgent/referralAgentService';

class ReferralAgentStore extends CrudStoreBase<ReferralAgentDto>{
	constructor() {
		super(referralAgentService, defaultReferralAgent)
	}
}

export const defaultReferralAgent: ReferralAgentDto = {
	id: '',
    name: '',
    email: '',
    phoneNumber: '',
    expirationDate: '',
    isActive: false,
    token: '',
    lastModificationTime: '',
    lastModifierUserId: 0,
    creationTime: '',
    creatorUserId: 0,
    referralLink: '',
}

export default ReferralAgentStore;